import { takeLatest } from "redux-saga/effects";

import { ActionType } from "./types/actionType";
import {
  handleCreateMrnCategory,
  handleUpdateMrnCategory,
  handleDeleteMrnCategory,
  handleRetrieveMrnCategory,
  handleRetrieveManyMrnCategories,
} from "./workers";

export function* watcher() {
  yield takeLatest(ActionType.CREATE_MRN_CATEGORY, handleCreateMrnCategory);
  yield takeLatest(ActionType.UPDATE_MRN_CATEGORY, handleUpdateMrnCategory);
  yield takeLatest(ActionType.DELETE_MRN_CATEGORY, handleDeleteMrnCategory);
  yield takeLatest(ActionType.RETRIEVE_MRN_CATEGORY, handleRetrieveMrnCategory);
  yield takeLatest(ActionType.RETRIEVE_MANY_MRN_CATEGORIES, handleRetrieveManyMrnCategories);
}

